// services/api/studentService.js
import API from '../api/api';

export const studentService = {
  getStudentGroups: async (locationId, tutorId, semesterId) => {
    const response = await API.get('/get_student_groups', {
      params: { 
        location_id: locationId, 
        tutor_id: tutorId, 
        semester_id: semesterId 
      }
    });
    return response.data.data || [];
  },

  getStudentFile: async (params) => {
    const response = await API.get('/get_student_file', { params });
    return response.data || null;
  },

  getStudentFileUrl: async (inputKey) => {
    const response = await API.get('/get_student_file_url', {params: {input_key: inputKey}});
    return response.data
  },


  getStudentInfo: async (student_id) => {
    const response = await API.get('/get_student_info', { params: { student_id } });
    return response.data || {};
  },

  searchForStudents: async (payload) => {
    const response = await API.get("/student_search", { params: {...payload} });
    return response.data.data || [];
  },

  getStudents: async (locationId) => {
    const response = await API.get('/get_students', {
      params: { 
        locationId: locationId}
    });
    return response.data.data || [];
  },

  getStudentAttendies: async (group_id) => {
    const response = await API.get('/get_group_attendies', {
      params: { 
        group_id: group_id}
    });
    return response.data.data || [];
  },

  createStudentGroup: async (payload) => {
    const response = await API.post("/create_student_group", {...payload});
    return response.data;
  },

  updateStudentGroup: async (payload) => {
    const response = await API.post("/update_student_group", {...payload});
    return response.data;
  },

  createStudentGroupAttendies: async (students, group_id) => {
    const response = await API.post("/create_student_group_attendies", {students, group_id});
    return response.data;
  },

  deleteStudent: async (id) => {
    const response = await API.post("/delete_student",{id});
    return response.data;
  },
  deleteStudentGroup: async (id) => {
    const response = await API.post("/delete_student_group",{id});
    return response.data;
  }
};


